import { render, staticRenderFns } from "./OrderDetailsDialog.vue?vue&type=template&id=86c31d36&scoped=true"
import script from "./OrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsDialog.vue?vue&type=style&index=0&id=86c31d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c31d36",
  null
  
)

export default component.exports